const MS_PER_HOUR = 60 * 60 * 1000;
export const SOLD_GRACE_HOURS = 48;
export const SOLD_GRACE_MS = SOLD_GRACE_HOURS * MS_PER_HOUR;

export function getSoldExpiresAt(soldAt) {
  if (!soldAt) return null;
  const date = new Date(soldAt);
  if (Number.isNaN(date.getTime())) return null;
  return new Date(date.getTime() + SOLD_GRACE_MS);
}

export function getSoldState(product) {
  const soldAtValue = product?.sold_at || product?.soldAt || null;
  if (!soldAtValue) {
    return {
      isSold: false,
      isInGrace: false,
      isExpired: false,
      graceHoursLeft: 0,
      expiresAt: null,
    };
  }

  const soldAtDate = new Date(soldAtValue);
  if (Number.isNaN(soldAtDate.getTime())) {
    return {
      isSold: false,
      isInGrace: false,
      isExpired: false,
      graceHoursLeft: 0,
      expiresAt: null,
    };
  }

  const expiresAt = new Date(soldAtDate.getTime() + SOLD_GRACE_MS);
  const now = Date.now();
  const isInGrace = now < expiresAt.getTime();
  const isExpired = !isInGrace;
  const graceHoursLeft = isInGrace
    ? Math.max(0, Math.ceil((expiresAt.getTime() - now) / MS_PER_HOUR))
    : 0;

  return {
    isSold: true,
    isInGrace,
    isExpired,
    graceHoursLeft,
    expiresAt,
  };
}
